import React, { useState, useEffect } from 'react';
import ApiDocs from './ApiDocs';
import Blog from './Blog';
import Contact from './Contact';
import PrivacyPolicy from './PrivacyPolicy';
import Terms from './Terms';
import WhatsAppWidget from './WhatsAppWidget';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    {
      q: 'Apa itu xharely dan solusi apa yang disediakan?',
      a: 'xharely (PT Xharely Teknologi Indonesia) adalah software development company dan penyedia solusi teknologi digital. Kami membangun produk SaaS inovatif seperti xharelyPOS serta melayani pengembangan custom software untuk transformasi bisnis modern.'
    },
    {
      q: 'Apa itu xharelyPOS dan jenis usaha apa yang cocok?',
      a: 'xharelyPOS adalah sistem kasir online (Point of Sale) berbasis cloud yang dilengkapi manajemen inventaris stok, multi-outlet, laporan keuangan real-time, dan struk digital. Sangat cocok untuk bisnis Retail, Toko Kelontong, Cafe, Restoran, dan UMKM.'
    },
    {
      q: 'Apakah xharelyPOS mendukung metode pembayaran digital dan non-tunai?',
      a: 'Ya, xharelyPOS mendukung integrasi multi-metode pembayaran mulai dari Tunai, QRIS otomatis, Transfer Bank (Virtual Account), hingga e-Wallet.'
    },
    {
      q: 'Bagaimana cara memulai konsultasi proyek digital dengan tim xharely?',
      a: 'Anda dapat menghubungi tim kami melalui formulir Contact di website, atau langsung menghubungi WhatsApp resmi kami di +62 851-2121-0306.'
    },
    {
      q: 'Apakah data bisnis dan transaksi aman disimpan di cloud xharely?',
      a: 'Sangat aman. Seluruh data transaksi dan informasi bisnis dienkripsi dengan standar keamanan tinggi (SSL/TLS 256-bit) dan didukung backup data otomatis di server cloud terpercaya.'
    }
  ];

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCurrentSlide(prev => prev === 2 ? 0 : prev + 1);
    }, 3000);
    return () => clearInterval(interval);
  }, [isPaused]);

  const approaches = [
    {
      image: '/approach/approach_Illustration_1.svg?v=1',
      title: 'Product Innovation',
      description: 'Mengembangkan produk yang memecahkan masalah bisnis nyata dengan teknologi terdepan.'
    },
    {
      image: '/approach/approach_Illustration2.svg?v=1',
      title: 'Scalable Solutions',
      description: 'Produk yang dapat berkembang seiring pertumbuhan bisnis dengan arsitektur yang robust.'
    },
    {
      image: '/approach/approach_Illustration_3.svg?v=2',
      title: 'Business Impact',
      description: 'Fokus pada hasil yang terukur dan memberikan ROI yang signifikan untuk bisnis Anda.'
    }
  ];

  if (currentPage === 'docs') {
    return (
      <>
        <ApiDocs onBack={() => setCurrentPage('home')} />
        <WhatsAppWidget />
      </>
    );
  }
  
  if (currentPage === 'contact') {
    return (
      <>
        <Contact onBack={() => setCurrentPage('home')} />
        <WhatsAppWidget />
      </>
    );
  }

  if (currentPage === 'privacy') {
    return (
      <>
        <PrivacyPolicy onBack={() => setCurrentPage('home')} />
        <WhatsAppWidget />
      </>
    );
  }

  if (currentPage === 'terms') {
    return (
      <>
        <Terms onBack={() => setCurrentPage('home')} />
        <WhatsAppWidget />
      </>
    );
  }

  if (currentPage === 'blog') {
    return (
      <>
        <Blog onBack={() => setCurrentPage('home')} />
        <WhatsAppWidget />
      </>
    );
  }
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="fixed top-0 w-full bg-white/90 backdrop-blur-md z-50 border-b border-gray-100">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <img src="/x-logo.svg" alt="xharely logo - menghubungkan ide membangun solusi" className="h-10 w-10" />
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => setCurrentPage('home')} className="text-gray-700 hover:text-black transition font-medium">Home</button>
            <a href="#about" className="text-gray-700 hover:text-black transition font-medium">About</a>
            <a href="#faq" className="text-gray-700 hover:text-black transition font-medium">FAQ</a>
            <button onClick={() => setCurrentPage('blog')} className="text-gray-700 hover:text-black transition font-medium">Blog</button>
            <button onClick={() => setCurrentPage('docs')} className="text-gray-700 hover:text-black transition font-medium">API Docs</button>
            <button onClick={() => setCurrentPage('contact')} className="bg-black text-white px-6 py-2 rounded-full hover:bg-gray-800 transition font-medium">
              Contact
            </button>
          </div>
          <button 
            className="md:hidden text-black"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={mobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </nav>
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100">
            <div className="px-6 py-4 space-y-4">
              <button onClick={() => { setCurrentPage('home'); setMobileMenuOpen(false); }} className="block w-full text-left text-gray-700 hover:text-black transition font-medium">Home</button>
              <a href="#about" onClick={() => setMobileMenuOpen(false)} className="block text-gray-700 hover:text-black transition font-medium">About</a>
              <a href="#faq" onClick={() => setMobileMenuOpen(false)} className="block text-gray-700 hover:text-black transition font-medium">FAQ</a>
              <button onClick={() => { setCurrentPage('blog'); setMobileMenuOpen(false); }} className="block w-full text-left text-gray-700 hover:text-black transition font-medium">Blog</button>
              <button onClick={() => { setCurrentPage('docs'); setMobileMenuOpen(false); }} className="block w-full text-left text-gray-700 hover:text-black transition font-medium">API Docs</button>
            </div>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section id="home" className="pt-24 pb-20 bg-gradient-to-br from-white via-gray-50 to-yellow-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-bold mb-8 leading-tight">
                <span className="block sm:inline">Hubungkan Ide,</span>
                <br className="hidden sm:block" />
                <span className="block sm:inline">Bangun Solusi</span>
                <br />
                <span className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 mt-4 sm:mt-0">
                  <span>Bersama</span>
                  <img src="/x-logo-text.svg" alt="xharely - menghubungkan ide membangun solusi digital" className="h-12 sm:h-16 md:h-20 lg:h-24 drop-shadow-sm inline-block" />
                </span>
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto mb-12 px-4">
                Transformasi digital dimulai dari ide inovatif. Kami membangun solusi yang tepat untuk masa depan bisnis Anda.
              </p>
              <div className="flex justify-center">
                <button onClick={() => setCurrentPage('contact')} className="border border-black text-black px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium hover:bg-black hover:text-white transition text-base sm:text-lg">
                  Let's Get Coffee
                </button>
              </div>
            </div>
            
            {/* Hero Visual */}
            <div className="relative">
              <div className="bg-black rounded-3xl p-8 md:p-16 text-center">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center">
                  <div className="text-center">
                    <div className="text-2xl md:text-3xl font-bold text-yellow-500 mb-2">xharelyPOS</div>
                    <div className="text-sm text-yellow-500">Available Now</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl md:text-3xl font-bold text-[#DB2777] mb-2">xharelyEvent</div>
                    <div className="text-sm text-gray-500">Q1 2027</div>
                  </div>
                </div>
                <div className="mt-8 text-gray-500 text-lg">
                  Built for modern businesses
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-black mb-4">Solusi Digital Kami</h2>
            <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto px-4">
              Produk inovatif yang menghubungkan ide dengan implementasi nyata
            </p>
          </div>
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-8">
              {/* xharelyPOS */}
              <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-2xl p-8 text-black relative overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-2xl">
                <div className="absolute top-4 right-4 bg-white text-black px-3 py-1 rounded-full text-sm font-semibold">
                  Tersedia Sekarang
                </div>
                <div className="flex flex-col lg:flex-row items-center gap-8">
                  <div className="lg:w-1/2">
                    <div className="w-20 h-20 bg-black rounded-xl flex items-center justify-center mb-6">
                      <img src="/product/x-logo-pos.svg" alt="xharelyPOS" className="h-10 w-10" />
                    </div>
                    <h3 className="text-3xl font-bold mb-4 text-black">xharelyPOS</h3>
                    <p className="text-gray-700 mb-6 text-lg">
                      Sistem Point of Sale modern yang mengintegrasikan penjualan, inventory, dan laporan dalam satu platform yang mudah digunakan.
                    </p>
                    <ul className="space-y-3 mb-6">
                      <li className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-black rounded-full"></div>
                        <span>Manajemen inventori real-time</span>
                      </li>
                      <li className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-black rounded-full"></div>
                        <span>Integrasi pembayaran lengkap</span>
                      </li>
                      <li className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-black rounded-full"></div>
                        <span>Analitik & laporan mendalam</span>
                      </li>
                    </ul>
                    <a href={process.env.REACT_APP_POS_URL || 'https://pos.xharely.com'} target="_blank" rel="noopener noreferrer" className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition inline-block">
                      Coba Sekarang
                    </a>
                  </div>
                  <div className="lg:w-1/2">
                    <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 opacity-75">
                      <div className="flex items-center gap-2 mb-4">
                        <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                        <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                        <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                      </div>
                      <div className="space-y-3 text-sm font-mono">
                        <div className="text-green-400">$ xharelypos --status</div>
                        <div className="text-green-400">✅ Siap Produksi</div>
                        <div className="text-green-400">✅ Multi-tenant support</div>
                        <div className="text-green-400">✅ Available at {(process.env.REACT_APP_POS_URL || 'https://pos.xharely.com').replace(/https?:\/\//, '')}</div>
                        <div className="text-yellow-400">Ready to use!</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* xharelyEvent */}
              <div className="bg-black rounded-2xl p-8 text-white relative overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-2xl">
                <div className="absolute top-4 right-4 bg-[#DB2777] text-white px-3 py-1 rounded-full text-sm font-semibold">
                  Coming Soon
                </div>
                <div className="flex flex-col lg:flex-row items-center gap-8">
                  <div className="lg:w-1/2">
                    <div className="w-20 h-20 bg-[#DB2777] rounded-xl flex items-center justify-center mb-6">
                      <img src="/product/x-logo-event.svg" alt="xharelyEvent" className="h-10 w-10" />
                    </div>
                    <h3 className="text-3xl font-bold mb-4 text-[#DB2777]">xharelyEvent</h3>
                    <p className="text-gray-300 mb-6 text-lg">
                      Platform manajemen event terpadu untuk mengorganisir acara dari registrasi hingga evaluasi dengan mudah dan efisien.
                    </p>
                    <ul className="space-y-3 mb-6">
                      <li className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                        <span>Event registration & ticketing</span>
                      </li>
                      <li className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                        <span>Attendee management system</span>
                      </li>
                      <li className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                        <span>Real-time analytics & insights</span>
                      </li>
                    </ul>
                    <button className="bg-gray-600 text-gray-300 px-6 py-3 rounded-lg font-semibold cursor-not-allowed" disabled>
                      Notify Me
                    </button>
                  </div>
                  <div className="lg:w-1/2">
                    <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 opacity-75">
                      <div className="flex items-center gap-2 mb-4">
                        <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                        <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                        <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                      </div>
                      <div className="space-y-3 text-sm font-mono">
                        <div className="text-green-400">$ xharelyevent --preview</div>
                        <div className="text-gray-500">⏳ In development...</div>
                        <div className="text-gray-500">⏳ Beta testing phase</div>
                        <div className="text-gray-500">⏳ Expected Q1 2027</div>
                        <div className="text-green-400">Stay tuned for updates</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="about" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight">
              Our approach
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Kami fokus mengembangkan produk digital yang dapat memberikan dampak nyata bagi pertumbuhan dan efisiensi bisnis Anda.
            </p>
          </div>
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              <div>
                <div className="relative">
                  <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
                    <div className="text-center mb-6">
                      <div className="transform transition-all duration-700 ease-out animate-pulse">
                        <img src={approaches[currentSlide].image} alt={approaches[currentSlide].title} className="w-48 sm:w-64 md:w-80 h-48 sm:h-64 md:h-80 object-contain mx-auto mb-4 transform transition-all duration-700 ease-out hover:scale-105" />
                      </div>
                      <div className="transform transition-all duration-500 ease-out opacity-0 animate-fade-in" style={{animation: 'fadeInUp 0.6s ease-out forwards'}}>
                        <h3 className="text-xl sm:text-2xl font-semibold mb-4">{approaches[currentSlide].title}</h3>
                        <p className="text-gray-600 text-base sm:text-lg px-4">{approaches[currentSlide].description}</p>
                      </div>
                    </div>
                    <div className="flex justify-center items-center gap-4">
                      <button onClick={() => setCurrentSlide(currentSlide === 0 ? 2 : currentSlide - 1)} className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                      </button>
                      <div className="flex gap-2">
                        {approaches.map((_, index) => (
                          <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition ${currentSlide === index ? 'bg-black' : 'bg-gray-300'}`} />
                        ))}
                      </div>
                      <button onClick={() => setCurrentSlide(currentSlide === 2 ? 0 : currentSlide + 1)} className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-100 rounded-3xl p-8 md:p-12">
                <div className="text-center">
                  <div className="text-6xl font-bold text-gray-300 mb-4">3</div>
                  <p className="text-gray-600 text-lg mb-8">Core principles</p>
                  <div className="grid grid-cols-3 gap-4 text-center">
                    <div>
                      <div className="text-lg font-bold text-gray-700">Innovation</div>
                      <div className="text-gray-500 text-sm">Technology driven</div>
                    </div>
                    <div>
                      <div className="text-lg font-bold text-gray-700">Scale</div>
                      <div className="text-gray-500 text-sm">Growth ready</div>
                    </div>
                    <div>
                      <div className="text-lg font-bold text-gray-700">Impact</div>
                      <div className="text-gray-500 text-sm">Results focused</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-20 bg-white border-t border-gray-100">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-black mb-4">Pertanyaan yang Sering Diajukan (FAQ)</h2>
            <p className="text-gray-600 text-lg">Pelajari lebih lanjut tentang produk, solusi, dan layanan teknologi xharely.</p>
          </div>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border border-gray-200 rounded-2xl overflow-hidden transition duration-200 hover:border-gray-300">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full px-6 py-5 text-left font-semibold text-gray-900 flex justify-between items-center bg-gray-50/50 hover:bg-gray-50 transition"
                >
                  <span className="text-base sm:text-lg pr-4">{faq.q}</span>
                  <span className="text-xl text-gray-500 font-mono transition-transform duration-200">
                    {openFaq === index ? '−' : '+'}
                  </span>
                </button>
                {openFaq === index && (
                  <div className="px-6 py-5 bg-white text-gray-600 leading-relaxed text-sm sm:text-base border-t border-gray-100">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-black py-20">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
            Ready to transform
            <br />
            your business?
          </h2>
          <p className="text-lg sm:text-xl text-white mb-12 max-w-2xl mx-auto px-4">
            Mulai transformasi digital bisnis Anda dengan solusi xharely yang sudah terbukti dan siap digunakan.
          </p>
          <button onClick={() => setCurrentPage('contact')} className="bg-white text-black px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium hover:bg-gray-200 transition text-base sm:text-lg">
            Let's Get Coffee
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white pt-16 pb-12 border-t border-gray-100">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-12 border-b border-gray-100">
            {/* Brand Column */}
            <div className="space-y-4">
              <img src="/x-logo-text.svg" alt="xharely - menghubungkan ide membangun solusi digital" className="h-8 md:h-10 w-auto" />
              <p className="text-gray-600 text-sm leading-relaxed max-w-sm">
                Menghubungkan ide inovatif dengan solusi digital terbaik untuk mempercepat pertumbuhan dan efisiensi bisnis Anda.
              </p>
            </div>

            {/* Office Address Column */}
            <div className="space-y-3">
              <h3 className="text-sm font-bold uppercase tracking-wider text-black">Alamat Kantor</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Jl. Kayangan, Tangkerang Barat, Marpoyan Damai, Pekanbaru, Riau, Indonesia (28282)
              </p>
            </div>

            {/* Contact Column */}
            <div className="space-y-3">
              <h3 className="text-sm font-bold uppercase tracking-wider text-black">Hubungi Kami</h3>
              <ul className="space-y-2.5 text-sm text-gray-600">
                <li>
                  <a 
                    href="https://wa.me/6285121210306?text=Halo%20xharely%2C%20saya%20tertarik%20untuk%20konsultasi%20layanan%20pengembangan%20software%20%2F%20solusi%20digital." 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center gap-2.5 text-gray-700 hover:text-green-600 transition font-medium"
                  >
                    <svg className="w-5 h-5 text-green-500 fill-current flex-shrink-0" viewBox="0 0 24 24">
                      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
                    </svg>
                    <span>WhatsApp: +62 851-2121-0306</span>
                  </a>
                </li>
                <li>
                  <a 
                    href="mailto:contact@xharely.com" 
                    className="inline-flex items-center gap-2.5 text-gray-700 hover:text-black transition font-medium"
                  >
                    <svg className="w-5 h-5 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <span>Email: contact@xharely.com</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>&copy; {new Date().getFullYear()} PT Xharely Teknologi Indonesia. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <button onClick={() => setCurrentPage('blog')} className="hover:text-black transition">
                Blog
              </button>
              <button onClick={() => setCurrentPage('privacy')} className="hover:text-black transition">
                Kebijakan Privasi
              </button>
              <button onClick={() => setCurrentPage('terms')} className="hover:text-black transition">
                Syarat & Ketentuan
              </button>
            </div>
          </div>
        </div>
      </footer>
      <WhatsAppWidget />
    </div>
  );
}

export default App;